<template>
  <div class="ml-2 delivery-address-tile ">
    <button class="close mt-2 mr-2 bg-light">
      <b-icon-x @click="$emit('quit')" />
    </button>
    <section class="mx-3 mt-3">
      <h4 class="text-black-50 ml-40px">
        Versandadresse
      </h4>

      <div class="d-block font-form mt-3">
        <form>
          <AddressForm
            v-model="address"
            :activeAutocomplete="activeAutocomplete"
            :autocomplete="autocomplete"
            :config="form.config"
            :selectFromAutoComplete="selectFromAutoComplete"
            :getAddressSuggestions="handleOnGetAddressSuggestions"
            :validations="form.validations.deliveryAddress"
          />

          <div class="row mt-4">
            <div class="col-6">
              <button
                class="futalis-btn futalis-button-orange text-white text-center "
                @click="$emit('saveClient', $event)"
              >
                Speichern
              </button>
            </div>
            <div v-if="form.displayMode ===  'edit'" class="col-6">
              <a
                  @click="$emit('deleteClient', form.data.id, form.data.isPraxis)"
                  class="float-left mt-2"
                  style="color: rgba(0,0,0,.5); cursor: pointer;"
              >
                Entfernen <span><i class="fal fa-trash-can clickable vertical-align-middle"/></span>
              </a>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import AddressForm from './AddressForm';
export default {
  name: 'DeliveryAddress',
  components: { AddressForm },
  props: [
    'form',
    'selectAutoComplete',
    'autocomplete',
    'getAddressSuggestions'
  ],
  methods: {
    selectFromAutoComplete(field, value) {
      this.selectAutoComplete(field, value);
    },
    handleOnGetAddressSuggestions(field) {
      this.getAddressSuggestions('deliveryAddress', field);
    },
    updateFormValue(key, value) {
      this.$emit('updateForm', {
        ...this.form,
        data: { ...this.form.data, [key]: value }
      });
    }
  },
  computed: {
    address: {
      get() {
        return this.form.data.deliveryAddress;
      },
      set(value) {
        this.updateFormValue('deliveryAddress', value);
      }
    },
    activeAutocomplete() {
      return (
        this.form.data.deliveryAddress.country === 'DE' &&
        this.autocomplete.addressType === 'deliveryAddress'
      );
    }
  }
};
</script>

<style scoped>
.delivery-address-tile {
  width: 318px;
  height: 768px;
}
.font-form {
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .delivery-address-tile {
    height: 480px !important;
    width: 100% !important;
    position: absolute;
    top: 645px;
    margin-left: 0 !important;
  }
}
</style>